import { motion } from 'framer-motion';

const CALENDLY_URL = 'https://calendly.com/ai-scale-hq/30min';

export const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="py-10 border-t border-white/5" data-testid="footer">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2">
            <div className="w-7 h-7 bg-[#6C4DFF] rounded-lg flex items-center justify-center">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
              </svg>
            </div>
            <span className="text-lg font-bold text-white tracking-tight">
              Scale<span className="text-[#6C4DFF]">HQ</span>
            </span>
          </a>

          {/* Links */}
          <div className="flex items-center gap-6">
            <button onClick={() => scrollToSection('problem')} className="text-sm text-white/40 hover:text-white/70 transition-colors">
              Problem
            </button>
            <button onClick={() => scrollToSection('solution')} className="text-sm text-white/40 hover:text-white/70 transition-colors">
              Solution
            </button>
            <button onClick={() => scrollToSection('services')} className="text-sm text-white/40 hover:text-white/70 transition-colors">
              Services
            </button>
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-[#6C4DFF] hover:text-[#8468FF] transition-colors"
            >
              Book a Call
            </a>
          </div>

          {/* Copyright */}
          <p className="text-sm text-white/30">
            © {new Date().getFullYear()} ScaleHQ
          </p>
        </div>
      </div>
    </footer>
  );
};
